import React from 'react';
import edu from '../../../img/Icons/Update/Education.png'
import IconLarge from '../../GeneralSubcomponents/IconLarge'
import '../../../Styles/education.css'

const Education = () => (

    <div className="edu">
        <div className="row o-icon-title "><IconLarge iconL={edu} /><p> &nbsp; Education</p></div>
        <div className="o-exp-item">
            <div className="row o-edu-op">
                <div className="col-sm-8"><p className="o-edu">Universidad Autónoma de Occidente</p></div>
                <div className="col-sm-4"><p className="o-age">Jul, 2016- Oct, 2022</p></div>
            </div>
            <div className="row "><p className="o-det col-sm-12"> Bachelor's Degree in Multimedia Engineer</p></div>
        </div>
    </div>

);
export default Education;